import React from "react";
import card from "../../assets/img/card.svg";
import transfer from "../../assets/img/transfer.png";
import cardNull from "../../assets/img/card-null.png";
import transferNull from "../../assets/img/transfer-null.png";
import padlock from "../../assets/img/padlock.svg";
import cancel from "../../assets/img/cancel.svg";
import "./index.scss";
import { usePayDataContext } from "../../contexts/PayDataContext";

const NavigationBar = ({ setMenu, menu }) => {
  const { isLoading, handleGenerateNewAccount } = usePayDataContext();

  const handleTransferClick = async () => {
    await handleGenerateNewAccount();
    setMenu("transfer");
  };

  return (
    <div className="flex navigationBar">
      <div className="sideBar">
        <h6 className="mt-4 py-5 pl-7 Inter-Semibold">PAYMENT METHOD</h6>
        <div className="mt-5 pb-5">
          <div
            className="flex items-center payment pt-3 mt-5"
            onClick={() => setMenu("card")}
          >
            <span
              className={`w-[9px] h-9 bg-[var(--SarepayPrimary-color)] rounded-[40px] ml-0.5 ${
                menu === "card" ? "visible" : "invisible"
              }`}
            ></span>

            <div className="flex items-center gap-3 pl-7">
              <img src={menu === "card" ? card : cardNull} alt="cardNull" />
              <p
                className={`text-sm Inter-Regular ${
                  menu === "card" ? "text-[var(--SarepayPrimary-color)]" : "text-[#727272]"
                }`}
              >
                Card
              </p>
            </div>
          </div>

          <div
            className={`flex payment items-center pt-3 mt-5 mb-5 ${
              isLoading && "pointer-events-none"
            }`}
            onClick={handleTransferClick}
          >
            <span
              className={`w-[9px] h-9 bg-[var(--SarepayPrimary-color)] rounded-[40px] ml-0.5 ${
                menu === "transfer" ? "visible" : "invisible"
              }`}
            ></span>

            <div className="flex items-center gap-3 pl-7">
              <img
                src={menu === "transfer" ? transfer : transferNull}
                alt="transferNull"
              />
              <p
                className={`text-sm Inter-Regular ${
                  menu === "transfer" ? "text-[var(--SarepayPrimary-color)]" : "text-[#727272]"
                }`}
              >
                Transfer
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="mobileBottom hidden pt-5 w-full bg-white">
        <div
          className="w-full flex justify-center mb-5 "
          onClick={() => setMenu("card")}
        >
          <div className="cancelPayment rounded flex justify-center">
            <img src={cancel} alt="cancel" className="mr-2" />
            <button>Cancel Payment</button>
          </div>
        </div>
        <div className="flex justify-center w-full pt-10 pb-10 secured">
          <img src={padlock} alt="padlock" className="w-3 h-3 mr-3 mt-1" />
          <p>
            Secured by <span>BT Payment</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NavigationBar;
